import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import Stat from "./Stat";
import {
  closeTooltip,
  openTooltip, toggleResourceStats
} from "../../../store/actions";
import { isTouchScreen } from "../../../lib/elementUtilities";

const Stats = (props) => {
  const armyCapacityStatRef = useRef();
  const populationDivRef = useRef();
  const developmentDivRef = useRef();

  const [showStatsDialog, setShowStatsDialog] = useState(false);

  useEffect(() => {
    if (!props.showResourcesStatistics && showStatsDialog) {
      setShowStatsDialog(false);
    }
  }, [props.showResourcesStatistics])

  const handleToggleStatsDialog = () => {
    props.toggleResourceStatsDispatch();
    setShowStatsDialog(!showStatsDialog);
  }

  console.log(props.resources);
  console.log(props.resourceBalances);
  return (
    (props.resources && props.resourceBalances
      && <div className="stats">
        {!props.inDialog && <div className={"stats-menu-wrap"}>
          <a className="dark-grey" onClick={handleToggleStatsDialog}>Res</a>
          <a onClick={handleToggleStatsDialog} className="menu-toggle open link">
            <i className={`chevron ${props.showResourcesStatistics ? "chevron-up" : "chevron-down"}`}/>
          </a>
        </div>}
        <div className="stat-item stat-big">
          <Stat
            resourceName="grain"
            resourceAmount={props.resources.grain}
            resourceBalance={props.resourceBalances.grain.production
            - props.resourceBalances.grain.consumption}
            limitReached={props.resourceBalances.grain.limit.amount
            > props.resourceBalances.grain.limit.limit}
            iconClass="obili"
            hover={elementRef => props.openTooltip({
              name: "GrainBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
          <Stat
            resourceName="food"
            resourceBalance={
              props.resourceBalances.food.realProduction - props.resourceBalances.food.consumption
            }
            resourceBalanceEffective={
              !(props.resourceBalances.food.realProduction
                < props.resourceBalances.food.maxProduction)
            }
            iconClass="jidlo"
            hover={elementRef => props.openTooltip({
              name: "FoodBalance",
              dynamic: true,
              elementRef,
              // triggerDimension: {
              //   left: foodStatRef.current.getBoundingClientRect().left,
              //   bottom: foodStatRef.current.getBoundingClientRect().bottom,
              //   width: foodStatRef.current.getBoundingClientRect().width
              // }
            })}
            hoverOut={props.closeTooltip}
          />
        </div>
        <div className="stat-item stat-big">
          <Stat
            resourceName="stone"
            resourceAmount={props.resources.stone}
            resourceBalance={
              Object.values(props.resourceBalances.stone.production)
                .reduce((carry, num) => carry + num) - props.resourceBalances.stone.consumption
            }
            limitReached={props.resourceBalances.stone.limit.amount
            > props.resourceBalances.stone.limit.limit}
            iconClass="kameni"
            hover={elementRef => props.openTooltip({
              name: "StoneBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
          <Stat
            resourceName="bricks"
            resourceAmount={props.resources.bricks}
            resourceBalance={props.resourceBalances.bricks.realProduction}
            resourceBalanceEffective={
              !(props.resourceBalances.bricks.realProduction
                < props.resourceBalances.bricks.maxProduction)
            }
            limitReached={props.resourceBalances.bricks.limit.amount
            > props.resourceBalances.bricks.limit.limit}
            iconClass="infrastrukturni-body"
            hover={elementRef => props.openTooltip({
              name: "BricksBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
        </div>
        <div className="stat-item stat-big">
          <Stat
            resourceName="iron"
            resourceAmount={props.resources.iron}
            resourceBalance={
              Object.values(props.resourceBalances.iron.production)
                .reduce((carry, num) => carry + num) - props.resourceBalances.iron.consumption
            }
            limitReached={props.resourceBalances.iron.limit.amount
            > props.resourceBalances.iron.limit.limit}
            iconClass="zelezo"
            hover={elementRef => props.openTooltip({
              name: "IronBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
          <Stat
            resourceName="weapons"
            resourceAmount={props.resources.weapons}
            resourceBalance={props.resourceBalances.weapons.realProduction}
            resourceBalanceEffective={
              !(props.resourceBalances.weapons.realProduction
                < props.resourceBalances.weapons.maxProduction)
            }
            limitReached={props.resourceBalances.weapons.limit.amount
            > props.resourceBalances.weapons.limit.limit}
            iconClass="zbrane"
            hover={elementRef => props.openTooltip({
              name: "WeaponsBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
        </div>
        <div className="stat-item stat-big">
          <Stat
            resourceName="mana"
            resourceAmount={props.resources.mana}
            resourceBalance={
              Object.values(props.resourceBalances.mana.production)
                .reduce((carry, num) => carry + num) - props.resourceBalances.mana.consumption
            }
            limitReached={props.resourceBalances.mana.limit.amount
            > props.resourceBalances.mana.limit.limit}
            iconClass="mana"
            hover={elementRef => props.openTooltip({
              name: "ManaBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
          <Stat
            resourceName="magicEnergy"
            resourceAmount={props.resources.magicEnergy}
            resourceBalance={props.resourceBalances.magicEnergy.production}
            resourceBalanceEffective={
              !(props.resourceBalances.magicEnergy.production
                < props.resourceBalances.magicEnergy.maxProduction)
            }
            limitReached={props.resourceBalances.magicEnergy.limit.amount
            > props.resourceBalances.magicEnergy.limit.limit}
            iconClass="magie"
            hover={elementRef => props.openTooltip({
              name: "MagicEnergyBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
        </div>
        <div className="stat-item">
          <Stat
            resourceName="gold"
            resourceAmount={props.resources.gold}
            resourceBalance={
              Object.values(props.resourceBalances.gold.production)
                .reduce((carry, num) => carry + num)
              - Object.values(props.resourceBalances.gold.consumption)
                .reduce((carry, num) => carry + num)
            }
            limitReached={props.resourceBalances.gold.limit.amount
            > props.resourceBalances.gold.limit.limit}
            iconClass="zlato"
            hover={elementRef => props.openTooltip({
              name: "GoldBalance",
              dynamic: true,
              elementRef
            })}
            hoverOut={props.closeTooltip}
          />
        </div>
        <div className="stat-item clickable">
          <Stat
            resourceName="happiness"
            resourceAmount={props.happiness}
            resourceBalance={
              Object.values(props.resourceBalances.happiness)
                .reduce((carry, num) => carry + num) + 1
            }
            iconClass="popularita"
            click={elementRef => props.openTooltip({
              name: "HappinessBalance",
              dynamic: true,
              elementRef
            })}
          />
        </div>
        <div className="stat-item">
          <div
            className="stat"
            style={{ flexFlow: props.inDialog ? "wrap" : "initial" }}
            ref={populationDivRef}
            onMouseEnter={() => !isTouchScreen() && props.openTooltip({
              name: "PopulationBalance",
              dynamic: true,
              elementRef: populationDivRef
            })}
            onMouseOver={() => !isTouchScreen() && props.openTooltip({
              name: "PopulationBalance",
              dynamic: true,
              elementRef: populationDivRef
            })}
            onClick={() => isTouchScreen() && props.openTooltip({
              name: "PopulationBalance",
              dynamic: true,
              elementRef: populationDivRef
            })}
            onMouseLeave={!isTouchScreen() && props.closeTooltip}
          >
            <i className="icon icon-xmd icon-pop"/>
            {props.inDialog
              ? <><span className="value">
              <span>{props.population.total} ({props.population.free})</span>
        </span>
              <span>
              <span>{props.population.growth} / 100</span>
          <strong
            className={Object.values(props.resourceBalances.populationGrowth).reduce((carry, num) => carry + Number.parseInt(num, 10), 0) < 0 ? "negative" : "positive"}>
            &nbsp;({Object.values(props.resourceBalances.populationGrowth)
              .reduce((carry, num) => carry + Number.parseInt(num, 10), 0)})
          </strong>
              </span></>
              : <span className="value">
              <span>{props.population.total} ({props.population.free})</span>
              <span>
              <span>{props.population.growth} / 100</span>
          <strong
            className={Object.values(props.resourceBalances.populationGrowth).reduce((carry, num) => carry + Number.parseInt(num, 10), 0) < 0 ? "negative" : "positive"}>
            &nbsp;({Object.values(props.resourceBalances.populationGrowth)
              .reduce((carry, num) => carry + Number.parseInt(num, 10), 0)})
          </strong>
              </span>
        </span>}
          </div>
        </div>

        <div className={"stat-item"}>
          <Stat
            resourceName="ducats"
            resourceAmount={props.resources.ducats}
            resourceBalance={props.resourceBalances.ducats.production}
            limitReached={props.resourceBalances.ducats.limit.amount
            > props.resourceBalances.ducats.limit.limit}
            iconClass="trziste"
            hover={elementRef => props.openTooltip({
              name: "DucatsBalance",
              dynamic: true,
              elementRef
            })}
          />
        </div>

        <div className={"stat-item"}>
          <div
            className="stat"
            ref={armyCapacityStatRef}
            onMouseEnter={() => !isTouchScreen() && props.openTooltip({
              name: "ArmyCapacityDetail",
              dynamic: true,
              elementRef: armyCapacityStatRef
            })}
            onMouseOver={() => !isTouchScreen() && props.openTooltip({
              name: "ArmyCapacityDetail",
              dynamic: true,
              elementRef: armyCapacityStatRef
            })}
            onClick={() => isTouchScreen() && props.openTooltip({
              name: "ArmyCapacityDetail",
              dynamic: true,
              elementRef: armyCapacityStatRef
            })}
            onMouseLeave={!isTouchScreen() && props.closeTooltip}
          >
            <i className="icon icon-xmd icon-armada"/>
            <span className="value">
              {props.armyCapacityUsage.armyUnits} / {props.armyCapacityUsage.armyUnitsLimit}
            </span>
          </div>
        </div>

        <div className={"stat-item"}>
          <div
            className="stat"
            style={{ flexFlow: props.inDialog ? "wrap" : "initial" }}
            ref={developmentDivRef}
            onMouseEnter={() => !isTouchScreen() && props.openTooltip({
              name: "DevelopmentBalance",
              dynamic: true,
              elementRef: developmentDivRef
            })}
            onMouseOver={() => !isTouchScreen() && props.openTooltip({
              name: "DevelopmentBalance",
              dynamic: true,
              elementRef: developmentDivRef
            })}
            onClick={() => isTouchScreen() && props.openTooltip({
              name: "DevelopmentBalance",
              dynamic: true,
              elementRef: developmentDivRef
            })}
            onMouseLeave={!isTouchScreen() && props.closeTooltip}
          >
            <i className="icon icon-xmd icon-vedci"/>
            {props.inDialog
              ? <><span className="value">
              <span>{props.development.points}</span>
            </span>
              <span>
              <span>{props.development.partial} / 100</span>
              <strong
              className={Object.values(props.resourceBalances.development).reduce((carry, num) => carry + num) < 0 ? "negative" : "positive"}>
              &nbsp;({Object.values(props.resourceBalances.development)
                .reduce((carry, num) => carry + num)})
              </strong>
              </span></>
              : <span className="value">
              <span>{props.development.points}</span>
                <span>
              <span>{props.development.partial} / 100</span>
              <strong
                className={Object.values(props.resourceBalances.development).reduce((carry, num) => carry + num) < 0 ? "negative" : "positive"}>
              &nbsp;({Object.values(props.resourceBalances.development)
                  .reduce((carry, num) => carry + num)})
              </strong>
              </span>
            </span>}
          </div>
        </div>
      </div>) || <span>Loading</span>
  )
};

const mapStateToProps = state => ({
  resources: state.governorate.resources,
  resourceBalances: state.governorate.resourceBalances,
  happiness: state.governorate.happiness,
  population: state.governorate.population,
  development: state.governorate.development,
  armyCapacityUsage: state.governorate.armyCapacityUsage,
  showResourcesStatistics: state.ui.showResourcesStatistics
});

const mapDispatchToProps = dispatch => ({
  openTooltip: tooltipOptions => dispatch(openTooltip(tooltipOptions)),
  toggleResourceStatsDispatch: () => dispatch(toggleResourceStats()),
  closeTooltip: () => dispatch(closeTooltip())
});

export default connect(mapStateToProps, mapDispatchToProps)(Stats);
